import { render, staticRenderFns } from "./PbxCallData.vue?vue&type=template&id=a1df212a"
import script from "./PbxCallData.vue?vue&type=script&lang=js"
export * from "./PbxCallData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports